exports.onClientEntry = function(_, pluginParams) {
  if (process.env.NODE_ENV === 'production') {
    require.ensure(['raven-js'], function(require) {
      const Raven = require('raven-js');

      if (!Raven.isSetup()) Raven.config(pluginParams.dsn, pluginParams.config).install();
      window.Raven = Raven;
    });
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-sentry/gatsby-browser.js
// module id = 1132
// module chunks = 231608221292675